import { Dividers } from "Components/Dividers";
import React from "react";

export function CommaList(props: {
  items: React.ReactNode[];
  finalSeparator?: React.ReactNode;
}) {
  return Dividers({
    divider: props.finalSeparator
      ? i => (
          <>
            {props.items.length > 2 ? ", " : " "}
            {i === props.items.length - 1 && <>{props.finalSeparator} </>}
          </>
        )
      : ", ",
    children: props.items,
  });
}
